module.exports = __webpack_public_path__ + "static/img/wechat.ae7c599.png";


//////////////////
// WEBPACK FOOTER
// ./static/wechat.png
// module id = ISuj
// module chunks = 1